import { Outlet } from 'react-router';
import { connect } from 'dva';
import { Spin, Layout } from 'antd';

const AuthGuard = (props) => {
  const {
    appModel: { validCookie },
  } = props;

  return validCookie ? (
    <Outlet />
  ) : (
    <Spin
      tip="Loading"
      size="large"
    >
      <Layout />
    </Spin>
  );
};

export default connect(({ appModel }) => ({ appModel }))(AuthGuard);
